import {GameModeType} from '../enums/GameModeType.js';
import {TutorialFingerTypes} from '../enums/TutorialFingerTypes.js';
import {Mathf} from '../utils/Mathf.js';
import {NotifyPropertyChanged} from '../utils/NotifyPropertyChanged.js';

export class HUDModel extends NotifyPropertyChanged {
    private _gameMode: GameModeType = GameModeType.None;
    get gameMode(): GameModeType {
        return this._gameMode;
    }
    setGameMode(value: GameModeType) {
        this._gameMode = value;
        this.notifyPropertyChanged('gameMode');
    }

    private _score: number = 0;
    get score(): number {
        return this._score;
    }
    setScore(value: number) {
        this._score = value;
        this.notifyPropertyChanged('score');
    }

    private _showGameOver: boolean = false;
    get showGameOver(): boolean {
        return this._showGameOver;
    }
    setShowGameOver(value: boolean) {
        this._showGameOver = value;
        this.notifyPropertyChanged('showGameOver');
    }

    private _starCounter: number = 0;
    get starCounter() {
        return this._starCounter;
    }
    setStarCounter(value: number) {
        this._starCounter = value;
        this.notifyPropertyChanged('starCounter');
    }

    private _cupcakeCounter: number = 0;
    get cupcakeCounter() {
        return this._cupcakeCounter;
    }
    setCupcakeCounter(value: number) {
        this._cupcakeCounter = value;
        this.notifyPropertyChanged('cupcakeCounter');
    }

    private _showMaxedLevel: boolean = false;
    get showMaxedLevel(): boolean {
        return this._showMaxedLevel;
    }
    setShowMaxedLevel(value: boolean) {
        this._showMaxedLevel = value;
        this.notifyPropertyChanged('showMaxedLevel');
    }

    private _level: string = '';
    get level(): string {
        return this._level;
    }
    setLevel(value: string) {
        this._level = value;
        this.notifyPropertyChanged('level');
    }

    private _sliderValue: number = 0.001;
    get sliderValue(): number {
        return this._sliderValue;
    }
    setSliderValue(value: number) {
        value = Mathf.clamp(value, 0.001, 1);
        this._sliderValue = value;
        this.notifyPropertyChanged('sliderValue');
    }

    private _coins: number = 0;
    get coins(): number {
        return this._coins;
    }
    setCoins(value: number) {
        this._coins = value;
        this.notifyPropertyChanged('coins');
    }

    private _readySetGoText: string = '';
    get readySetGoText(): string {
        return this._readySetGoText;
    }
    setReadySetGoText(value: string) {
        this._readySetGoText = value;
        this.notifyPropertyChanged('readySetGoText');
    }

    private _malSpeech: string = '';
    public get malSpeech(): string {
        return this._malSpeech;
    }
    setMalSpeech(value: string) {
        this._malSpeech = value;
        this.notifyPropertyChanged('malSpeech');
    }

    private _lastWaveText: string = '';
    get lastWaveText(): string {
        return this._lastWaveText;
    }
    setLastWaveText(value: string) {
        this._lastWaveText = value;
        this.notifyPropertyChanged('lastWaveText');
    }

    private _tachometerValue: number = 0;
    get tachometerValue(): number {
        return this._tachometerValue;
    }
    setTachometerValue(value: number) {
        this._tachometerValue = value;
        this.notifyPropertyChanged('tachometerValue');
    }

    private _tutorialFinger: TutorialFingerTypes = TutorialFingerTypes.None;
    public get tutorialFinger(): TutorialFingerTypes {
        return this._tutorialFinger;
    }
    setTutorialFinger(value: TutorialFingerTypes) {
        this._tutorialFinger = value;
        this.notifyPropertyChanged('tutorialFinger');
    }
}
